import React from 'react'

export default function IconButton({
  onClick,
  disabled = false,
  children,
  ariaLabel,
  className = '',
}) {
  const baseClasses = 'w-8 h-8 bg-sky-900 text-white rounded-full flex items-center justify-center font-bold hover:bg-sky-800 disabled:bg-gray-300 disabled:cursor-not-allowed transition focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2'

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${className}`.trim()}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  )
}
